import net from '../../utils/net'
export default {
// 获取公司
  getownerlist (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 登录
  ordinaryLogin (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 企微登录
  QYLogin (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取公司购买模块
  OwnerModuleOpen (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取getUserAgentconfig
  // 获取
  getUserAgentconfig (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  }
}
